import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function for merging Tailwind CSS classes.
 * Combines clsx for conditional class composition with tailwind-merge
 * for intelligent class deduplication.
 *
 * @example
 * cn("px-4 py-2", condition && "bg-red-500", "px-6") // "py-2 px-6"
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
